module.exports = __webpack_public_path__ + "static/img/btn_ditu@2x.94aaffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/almaMater/btn_ditu@2x.png
// module id = U080
// module chunks = 1